module.exports = __webpack_public_path__ + "static/media/CCU_Arg-13.dfc7887b.png";